export default __webpack_public_path__ + "static/media/English4.7abe5fca.png";